module.exports = __webpack_public_path__ + "static/img/Hba1c.881c198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Hba1c.jpg
// module id = yrqb
// module chunks = 0